import { ClearanceItem } from '../clearance-item/clearance-item.model';
export class AdvancedSearchData{
    projectId:string;
    sortBy:string;
    sortOrder:string;
    status:string[];
    projectName:string;
    keyword:string;
    tags:string[];
    copyright:string;            
    author:string;    
    reportGroup:string;        
    deadline:string;    
    createdDate:string;            
    pageSize:number;
    pageStartIndex:number;
    episode: string;
    season: string;
   totalNumberOfRecords:number;
   getEntireDataset: boolean;
   resultSet:ClearanceItem[];
   constructor(){
     this.resultSet = [];
     this.totalNumberOfRecords = 0;
     this.getEntireDataset = false;
   }
 }